@use "@fukuri-admins/ui/layout" as *;

.container {
  width: 100%;
  padding: spacing("16");
  border-radius: borderRadius("lg");
  border: 1px solid border("Tertiary");
  @include elevation("1");
}

.sectionTitle {
  @include typography('Jp/16_W6');
  color: text('High');
  margin-bottom: spacing("12");
}

.content {
  display: flex;
  flex-direction: column;
  gap: spacing("12");
}

.status {
  display: flex;
  align-items: center;
  gap: spacing("12");
}

.statusText {
  @include typography('Jp/16_W3');
  color: text('Red');
  margin: 0;
}

.description {
  @include typography('Jp/14_W3');
  color: text('High');
  margin: 0;
  white-space: pre-line;
}